/*
 * Parent Services
 * Defines the application's services
 */

angular
  .module('sms.parent.services', [])

  .service('reportService', function ($http) {
    const reportService = {}
    // Verify PEN/date of birth combo and return student's emails
    reportService.getEmails = function (query) {
      return $http
        .get('/api/parent/emails', {
          params: query
        })
        .then(function (response) {
          return response.data
        })
        .catch(function () {
          return null
        })
    }
    reportService.generateToken = function (body) {
      const url = '/api/parent/tokens'
      return $http
        .post(url, body)
        .then(function () {
          return true
        })
        .catch(function () {
          return null
        })
    }
    return reportService
  })
